import type React from "react";
import type { LocalizedStringsMethods } from "react-localization";

export const createStringFormatters = (localizedStrings: LocalizedStringsMethods) => ({
  // wrapper for react-localization's formatString that returns a string
  formatString: (template: string, ...params: (string | number | Record<string, string | number>)[]): string =>
    localizedStrings.formatString(template, ...params).toString(),

  // wrapper for react-localization's formatString that returns an array of strings and components
  formatStringWithComponents: (
    template: string,
    ...params: (string | number | Record<string, string | number | React.JSX.Element> | React.JSX.Element)[]
  ): (string | number | React.JSX.Element)[] => {
    const result = localizedStrings.formatString(template, ...params);
    return Array.isArray(result) ? result : [result];
  },
});
